export const LEADER_BOARD = {
  SUCCESS_FETCH: "LEADER_BOARD_SUCCESS_FETCH",
  FAIL_FETCH: "LEADER_BOARD_FAIL_FETCH",
};
